import { InjectionToken } from '@angular/core';

export const PRIZM_DEFAULT_SIZE = new InjectionToken('' + 'default size for size derective');
